import * as React from "react";
import translate from "../../translations/i18n";
import CtaButton from "../ctaButton/ctaButton";
import "../../style/fonts.css";
import "./ResetPassword.css";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Props {}

class ResetPasswordSuccess extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div className="reset-password-cont">
        <div className="reset-password-cont-center">
          <div className="reset-password__headline">
            <div className="TITLE_2">
              {translate("NEW_PASSWORD_CONFIRMATION_WEB_TITLE")}
            </div>
          </div>
          <div className="reset-password__text">
            <div className="REG_TEXT ">
              {translate("NEW_PASSWORD_CONFIRMATION_WEB_TEXT")}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPasswordSuccess;



// WEBPACK FOOTER //
// ./src/components/resetPassword/ResetPasswordSuccess.tsx